/* MDM product card — quick add.
 *
 * Progressive enhancement only. The form is a real POST to /cart/add, so with
 * JS off or broken the button still works; it just navigates to the cart
 * instead of opening the drawer.
 */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Ask Dawn to re-render its own cart drawer and bubble, rather than
   * reimplementing either. Same approach as mdm-product.js. */
  function refreshCartUI() {
    var drawer = document.querySelector('cart-drawer');
    var bubble = document.getElementById('cart-icon-bubble');
    if (!drawer && !bubble) return;

    fetch(root() + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.remove('is-empty');
            if (typeof drawer.open === 'function') drawer.open();
          }
        }
        if (bubble && sections['cart-icon-bubble']) {
          var t2 = document.createElement('div');
          t2.innerHTML = sections['cart-icon-bubble'];
          var fb = t2.querySelector('#cart-icon-bubble');
          if (fb) bubble.innerHTML = fb.innerHTML;
        }
      })
      .catch(function () {
        /* the item is already in the cart server-side; only the UI is stale */
      });
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-mdm-card-form]');
    if (!form) return;

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-mdm-card-label]');
    var original = label ? label.textContent : '';

    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
    }
    if (label) label.textContent = 'Adding…';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: 1,
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = 'Added ✓';
        refreshCartUI();
        window.setTimeout(function () {
          if (label) label.textContent = original;
        }, 1800);
      })
      .catch(function () {
        /* fall back to the ordinary form post so the shopper is never stuck */
        form.submit();
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
        }
      });
  }

  document.addEventListener('submit', onSubmit);
})();
